import { connect } from 'react-redux';
import View from './FooterView';
import { selectedGoalSelector } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownSelector';
import { goals as goalsSelector } from '../FinancialPlanSelector';
import { setSubGoalType } from '../../FinancialPlanGoalDropdown/FinancialPlanGoalDropdownActions';
import { getGoalPageName } from '../../FinancialPlanOPL/Goals/utils/getGoalPageName';

const mapStateToProps = (state, ownProps) => {
  const goals = goalsSelector(state, ownProps);
  const currentGoal = selectedGoalSelector(state);

  if (!goals || !goals.length) {
    return {};
  }

  const fullGoalsList = goals.reduce((acc, goal) => {
    if (goal.DebtOutputPerType) {
      const debtOutputs = goal.DebtOutputPerType.map(output => ({
        label: output.TabLabel,
        value: output.DebtType,
        isSubGoal: true,
        parentGoalId: goal.GoalId,
        type: goal.GoalType,
      }));

      return [
        ...acc,
        {
          label: goal.GoalName,
          value: goal.GoalId,
          type: goal.GoalType,
        },
      ].concat(debtOutputs);
    }

    return [
      ...acc,
      {
        label: goal.GoalName,
        value: goal.GoalId,
        type: goal.GoalType,
      },
    ];
  }, []);

  const goalNavigation = fullGoalsList.reduce((acc, goal, index) => {
    if (currentGoal.GoalId === goal.value || currentGoal.DebtType === goal.value) {
      return {
        ...(index > 0 ? { prev: fullGoalsList[index - 1] } : {}),
        ...(index < fullGoalsList.length - 1 ? { next: fullGoalsList[index + 1] } : {}),
      };
    }
    return acc;
  }, []);

  return {
    goalObj: { ...currentGoal, ...goalNavigation },
  };
};

const mapDispatchToProps = dispatch => ({
  setGoalId: (goal, clientId) => {
    if (goal.isSubGoal) {
      dispatch(setSubGoalType(goal.value, clientId));

      ADV.util.Router.go2(getGoalPageName(goal.type), {
        clientId,
        goalId: goal.parentGoalId,
        workflowEnded: false,
        subGoalTypeId: goal.value,
      });
    } else {
      dispatch(setSubGoalType('', clientId));

      const goalPageName = goal.type ? getGoalPageName(goal.type) : 'NewFinancialPlanWhatIfs';

      ADV.util.Router.go2(goalPageName, {
        clientId,
        workflowEnded: false,
        goalId: goal.value,
      });
    }
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(View);
